export const FundingAuthorizationValues = ["Not Authorized", "Authorized", "Funding Authorization Not Applicable"] as const;
export type FundingAuthorization = typeof FundingAuthorizationValues[number];